// cell 单个item 权限
export enum CellItemAuth {
  LOGIN = 'LOGIN', // 需要登录
  CERTIFICATION = 'CERTIFICATION', // 需要实名认证
  SIGN_AGREEMENT = 'SIGN_AGREEMENT', // 需要签署协议
  FACECERTIFICATION = 'FACECERTIFICATION', // 需要人脸认证
  CONTRACT = 'CONTRACT', // 需要合同单据
}

export interface MyStaticCellType {
  type: string
  icon: string
  title: string
  auth: CellItemAuth[]
  router?: string
  params?: ''
}
